var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 47.97" }, props),
    React.createElement(
      "title",
      null,
      "block-icon-organizer"
    ),
    React.createElement(
      "g",
      { "data-name": "Layer 2" },
      React.createElement(
        "g",
        { "data-name": "Layer 1" },
        React.createElement("circle", { cx: "23.98", cy: "11.99", r: "11.99" }),
        React.createElement("path", { d: "M48 43.76a4 4 0 0 0 0-.83C46.53 36 35.53 27 24 27 11.69 27 0 36.69 0 43.89a4 4 0 0 0 4 4h40a4 4 0 0 0 3.78-2.74v-.11a3.93 3.93 0 0 0 .12-.51v-.36-.29c0-.1.1-.05.1-.12z" })
      )
    )
  );
});